import { render, staticRenderFns } from "./SimpleNavigator.vue?vue&type=template&id=1ac85903&scoped=true&"
import script from "./SimpleNavigator.vue?vue&type=script&lang=js&"
export * from "./SimpleNavigator.vue?vue&type=script&lang=js&"
import style0 from "./SimpleNavigator.vue?vue&type=style&index=0&id=1ac85903&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac85903",
  null
  
)

export default component.exports